export enum DownloadItemId {
  CommissioningLocalApplication = 'localApplication',
}
